import {Injectable, OnDestroy} from '@angular/core';
import {
    AbstractFindManyPaginatedService
} from '../../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {SaleProductModel} from '../../api/entity/saleProduct.model';
import {SaleProductRepository} from './ngrx/SaleProduct.repository';
import {SaleProductDataServiceAdapter} from './ngrx/SaleProductDataService.adapter';

@Injectable()
export class SaleProductPaginatedService extends AbstractFindManyPaginatedService<SaleProductModel, SaleProductModel> implements OnDestroy {

    constructor(repository: SaleProductRepository, dataServiceAdapter: SaleProductDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
